import type { MessageToolAnalysisDocument } from "@virtual-brain-lib/types";

export const UNLABELED_KEY = "__unlabeled__";

export interface AnalysisDocumentGroup {
	key: string;
	label: string | undefined;
	documents: MessageToolAnalysisDocument[];
}

export function groupAnalysisDocumentsBySourceLabel(
	documents: readonly MessageToolAnalysisDocument[],
): readonly AnalysisDocumentGroup[] {
	const map = new Map<string, AnalysisDocumentGroup>();

	for (const doc of documents) {
		const key = doc.sourceLabel ?? UNLABELED_KEY;
		const existing = map.get(key);

		if (existing) {
			existing.documents.push(doc);
			continue;
		}

		map.set(key, { key, label: doc.sourceLabel, documents: [doc] });
	}

	const groups = Array.from(map.values());

	groups.sort((a, b) => {
		if (a.key === UNLABELED_KEY) {
			return 1;
		}

		if (b.key === UNLABELED_KEY) {
			return -1;
		}

		return 0;
	});

	return groups;
}
